import { render } from "./RetailerMetaData.vue?vue&type=template&id=76ec91ac&scoped=true"
import script from "../js/retailer-meta-data.js?vue&type=script&lang=js"
export * from "../js/retailer-meta-data.js?vue&type=script&lang=js"

import "./RetailerMetaData.vue?vue&type=style&index=0&id=76ec91ac&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ec91ac"]])

export default __exports__